import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Container, Button, Row, Col, Input, Label, FormGroup, ModalHeader, ModalBody, ModalFooter, Form, UncontrolledTooltip } from 'reactstrap';
import { AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import i18n from '../../../../i18next';
import MaterialIcon from 'material-icons-react';
import {
    ADVANCED_BILLING,
    MENUU_ADMIN,
    MENUU_MASTER_ADMIN,
    SIMPLE_BILLING
} from '../../../../utils/Constants';

import {
    getPaymentSettings,
    resetPayment,
    canUserAccessPosSettings,
    resetUserAccessToPos,
    getRestaurantServiceFees,
    loadAllTenderTypes,
    updateRestaurantServiceFees,
    getPaymentProviders,
    updatedPaymentSettings
} from "../../../../actions/index";
import {
    getPriceWithCurrencySymbol,
    isUserAllowedToSeePaymentType,
    transformProductPrice,
    getCurrencySymbol
} from '../../../../utils/CommonUtils';
import ServiceFeesModal from './ServiceFeesModal';
import ConfirmationModal from '../../../common/ConfirmationModal';
import AvFeedback from 'availity-reactstrap-validation/lib/AvFeedback';
import Subscription from './menuuBilling/Subscription';
import AdditionalCharges from './menuuBilling/AdditionalCharges';
import CompanyInfo from './menuuBilling/CompanyInfo';
import BankAccount from './menuuBilling/BankAccount';
import Invoices from './menuuBilling/Invoices';
import InvoicesHistory from './menuuBilling/InvoicesHistory';
import AdditionalChargesHistory from './menuuBilling/AddittionalChargesHistory';

class PaymentScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            paymentSettingsId: -1,
            selectedPaymentType: "",
            providerType: null,
            paymentCode: "",
            settings: null,
            serviceFees: [],
            selectedServiceFee: {
                id: -1,
                amount: null,
                inFavorOfRestaurant: false,
                tenderType: {
                    id: -1,
                    value: 'Select type'
                },
                minAmount: 0.49,
                maxAmount: 2.99,
                percent: false
            },
            feeIndex: -1,
            userPassword: null,
            stateAlreadyCopiedFromProps: false,
            isFeesModalOpen: false,
            isStateChanged: false,
            isPaymentMethodChanged: false,
            isMenuuAdmin: false
        }

        this.changeState = this.changeState.bind(this);
        this.updatePaymentSettings = this.updatePaymentSettings.bind(this);
        this.checkUserPermission = this.checkUserPermission.bind(this);
        this.resetState = this.resetState.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleNewFee = this.handleNewFee.bind(this);
        this.toggleConfirmationWarning = this.toggleConfirmationWarning.bind(this);
        this.resetPaymentMethod = this.resetPaymentMethod.bind(this);
    }

    componentWillMount() {
        const restaurantId = this.props.match.params.id;
        this.props.getPaymentProviders();
        this.props.getPaymentSettings(restaurantId);
    }

    componentDidMount() {
        const { user } = this.props;

        this.setState({
            isMenuuAdmin: user.role === MENUU_ADMIN ? true : false
        })
        // Calling service fees from server
        this.props.getRestaurantServiceFees(this.props.match.params.id);
        this.props.loadAllTenderTypes();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.restaurant.serviceFees !== this.props.restaurant.serviceFees) {
            this.setState({
                ...this.state,
                serviceFees: this.props.restaurant.serviceFees
            });
        }

        if (prevProps.restaurant !== this.props.restaurant) {
            this.copyStateFromProps();
        }
    }

    componentWillUnmount() {
        this.props.resetUserAccessToPos();
        this.resetState();
    }

    resetState() {
        this.state.selectedPaymentType = "";
        this.state.connectedAccountId = "";
        this.state.paymentCode = "";
        this.state.serviceFees = [];
        this.state.selectedServiceFee = {};
        this.state.userPassword = null;
        this.state.stateAlreadyCopiedFromProps = false;
    }

    updatePaymentSettings() {
        const restaurantId = this.props.restaurant.id;
        this.props.updatedPaymentSettings(this.state, restaurantId);
    }

    checkUserPermission() {
        this.props.canUserAccessPosSettings(this.state.userPassword);
    }

    copyStateFromProps() {
        const { selectedPaymentType, providerType, paymentCode, paymentSettingsId, settings, serviceFees } = this.props.restaurant;

        this.setState({
            selectedPaymentType: selectedPaymentType && providerType ? selectedPaymentType : SIMPLE_BILLING,
            paymentCode: paymentCode,
            paymentSettingsId: paymentSettingsId,
            providerType: providerType,//? this.props.restaurant.providerType : (this.props.restaurant.selectedPaymentType === ADVANCED_BILLING ? this.props.restaurant.paymentProviders.filter(provider => provider.id === 1)[0] : null),
            settings: settings ? JSON.parse(settings) : '',
            serviceFees: serviceFees,
            stateAlreadyCopiedFromProps: true
        });
        // INCOMING
        // if (this.props.restaurant !== undefined && this.props.restaurant !== null &&
        //     this.props.restaurant.id !== undefined && this.props.restaurant.id !== -1 &&
        //     this.props.restaurant.selectedPaymentType !== "" && this.props.restaurant.connectedAccountId !== "" &&
        //     this.props.restaurant.paymentCode !== "" && this.props.restaurant.serviceFees !== undefined
        //     && !this.state.stateAlreadyCopiedFromProps) {

        //     this.setState({
        //         selectedPaymentType: this.props.restaurant.selectedPaymentType ? this.props.restaurant.selectedPaymentType : SIMPLE_BILLING,
        //         connectedAccountId: this.props.restaurant.connectedAccountId,
        //         paymentCode: this.props.restaurant.paymentCode,
        //         serviceFees: this.props.restaurant.serviceFees,
        //         stateAlreadyCopiedFromProps: true
        //     });
        // }
    }

    toggleModal(serviceFee, feeIndex) {
        this.setState({
            ...this.state,
            isFeesModalOpen: !this.state.isFeesModalOpen,
            selectedServiceFee: serviceFee ? serviceFee : {},
            feeIndex: feeIndex || feeIndex === 0 ? feeIndex : -1
        });
    }

    changeState({ target }) {
        let targetValue = target.value;
        if (target.name === 'providerType') {

            let index = target.selectedIndex;
            targetValue = {
                id: target.childNodes[index].id,
                value: target.value,
                template: target.childNodes[index].dataset.template
            };
        }

        this.setState({
            ...this.state,
            [target.name]: targetValue,
            settings: target.name === 'providerType' && targetValue.template ? this.transformEmptyTemplateToObject(targetValue.template) : this.state.settings
        });
    }

    changeSettingsState({ target }) {
        this.setState({
            ...this.state,
            settings: {
                ...this.state.settings,
                [target.name]: target.name === 'is3DS' || target.name === 'isDeferredCaptureContracted' ? target.checked : target.value
            }
        });
    }

    toggleConfirmationWarning() {
        this.setState({
            ...this.state,
            isPaymentMethodChanged: !this.state.isPaymentMethodChanged
        });
    }

    resetPaymentMethod() {
        const restaurantId = this.props.restaurant.id;
        let newBillingType = SIMPLE_BILLING;
        this.toggleConfirmationWarning();

        if (this.state.selectedPaymentType === SIMPLE_BILLING) {
            newBillingType = ADVANCED_BILLING;
        }

        this.props.resetPayment(restaurantId, () => this.setState({ ...this.state, selectedPaymentType: newBillingType }));
    }

    handleNewFee(serviceFee, removeFee) {
        let copyOfFees = this.state.serviceFees.slice(0);
        let isMatchFound = false;

        if ((this.state.feeIndex || this.state.feeIndex === 0) && !removeFee) {
            copyOfFees.map((fee, index) => {

                if (index === this.state.feeIndex) {
                    isMatchFound = true;
                    copyOfFees.splice(index, 1, serviceFee);
                }
            });
        } else if (removeFee) {
            copyOfFees.map((fee, feeIndex) => {
                if (feeIndex === this.state.feeIndex) {
                    copyOfFees.splice(feeIndex, 1);
                }
            });
        }

        if (!isMatchFound && !removeFee) {
            copyOfFees.push(serviceFee);
        }

        this.setState({
            ...this.state,
            serviceFees: copyOfFees,
            isStateChanged: true,   // triggers the warning msg
            isFeesModalOpen: false, // closes the modal instead of calling toggle because otherwise two setStates are called at the same causing bugs
            feeIndex: -1            // setts initial value to feeIndex to indicate that this is not edit mode
        });
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.header')}</span>
            </div>
        );
    }
    //  INCOMING
    // renderNotConnectedRestaurantContent() {
    //     const { stripeSymbolStyle, columnStyleUserAllowed, columnStyleUserNotAllowed, stripeButton, warningMsg } = styles;
    //     const { user, restaurant } = this.props;

    //     const columnStyle = (isUserAllowedToSeePaymentType(user, restaurant)) ? columnStyleUserAllowed : columnStyleUserNotAllowed;

    //     return (
    //         <Col style={columnStyle}>
    //             <p style={warningMsg}>
    //                 {i18n.t('screens:paymentScreen.connectWithStripeMsgFirstPart')}
    //                 <br />
    //                 {i18n.t('screens:paymentScreen.connectWithStripeMsgSecondPart')}
    //             </p>
    //             <div>
    //                 <Button color="primary" onClick={() => this.authorizeWithStripe()}>
    //                     <img src={stripeSymbol} width={10} style={stripeSymbolStyle} /> |
    //                     <span style={stripeButton}>{i18n.t('common:buttons.stripeButton')} </span>
    //                 </Button>
    //             </div>
    //         </Col>
    //     );
    // }

    // renderConnectedRestaurantContent() {
    //     const { columnStyleUserAllowed, columnStyleUserNotAllowed, warningMsg } = styles;
    //     const { user, restaurant } = this.props;
    //     const connectedAccountId = this.state.connectedAccountId;

    //     const columnStyle = (isUserAllowedToSeePaymentType(user, restaurant)) ? columnStyleUserAllowed : columnStyleUserNotAllowed;

    //     return (
    //         <Col style={columnStyle}>
    //             <p style={warningMsg}>{i18n.t('screens:paymentScreen.connectedRestaurantMsg')}</p>
    //             <p style={warningMsg}>{i18n.t('screens:paymentScreen.stripeId')}&nbsp;{connectedAccountId}</p>
    //         </Col>
    //     );
    // }

    renderBody() {
        const { paymentContainer, sensitiveInformationMsgRow, sensitiveInformationMsg, saveBtn } = styles;
        const { user, restaurant } = this.props;
        const role = user.role;
        const isMsgForSensitiveInfoHidden = (restaurant.connectedAccountId !== undefined && restaurant.connectedAccountId == null
            && restaurant.paymentCode !== undefined && restaurant.paymentCode == null) ? true : false;

        if (role === "MENUU_MASTER_ADMIN" || role === "MENUU_ADMIN") {
            return (
                <AvForm onValidSubmit={() => this.updatePaymentSettings()} style={{ display: 'flex', flexGrow: 1, width: '100%' }}>
                    <div style={{ width: '100%', display: 'flex', flexFlow: 'row wrap' }}>
                        <Col sm={12} md={12} style={paymentContainer}>
                            <Row style={sensitiveInformationMsgRow} hidden={isMsgForSensitiveInfoHidden}>
                                <span>
                                    <MaterialIcon icon="warning" color="#ffc107" size={20} />
                                </span>
                                <p style={sensitiveInformationMsg}>
                                    {i18n.t('screens:paymentScreen.sensitiveInformationMsg')}
                                </p>
                            </Row>
                            <div style={{ display: 'flex' }}>
                                {this.renderPaymentType()}
                                {(this.state.selectedPaymentType == SIMPLE_BILLING || !this.state.selectedPaymentType) ? this.renderSimpleBillingContent() : null}
                            </div>

                            {(this.state.selectedPaymentType == ADVANCED_BILLING) ? this.renderAdvancedBillingContent() : null}
                        </Col>
                        <Col sm={12} md={12} style={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'flex-end', paddingRight: 0 }}>
                            {/* onClick={() => this.updatePaymentSettings()} */}
                            <Button disabled={this.state.isMenuuAdmin} color="primary" style={{ display: 'flex' }}>
                                <span className="saveIcon" style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="save" color="#fff" size={18} /></span>
                                <span style={saveBtn}>{i18n.t('common:buttons.save')}</span>
                            </Button>
                        </Col>
                    </div>
                </AvForm>
            );
        }
    }

    renderPaymentType() {

        return (
            <Col sm={6} md={3} style={{ display: 'flex' }}>
                <Input disabled={this.state.isMenuuAdmin} type="select" name="selectedPaymentType" id="paymentType"
                    value={this.state.selectedPaymentType}
                    onChange={this.toggleConfirmationWarning}>
                    <option value={SIMPLE_BILLING}>{i18n.t('screens:paymentScreen.simpleBilling')}</option>
                    <option value={ADVANCED_BILLING}>{i18n.t('screens:paymentScreen.advancedBilling')}</option>
                </Input>
            </Col>
        )
    }

    renderSimpleBillingContent() {
        const { simpleBillingCol, simpleBillingLabel, noPadding } = styles;

        return (
            <Fragment>
                <Col md={3} style={simpleBillingCol}>
                    <Label md={7} style={simpleBillingLabel}>{i18n.t('screens:paymentScreen.paymentCode')}</Label>
                    <Col md={5} style={noPadding}>
                        <Input disabled={this.state.isMenuuAdmin} type="text" name="paymentCode"
                            placeholder={i18n.t('screens:paymentScreen.paymentCodePlaceholder')}
                            value={this.state.paymentCode}
                            onChange={this.changeState}
                            maxLength={16} />
                    </Col>
                </Col>
            </Fragment>
        )
    }

    renderAdvancedBillingContent() {
        const { selectedPaymentType, providerType, settings } = this.state;
        if (selectedPaymentType === SIMPLE_BILLING) return;
        const fields = providerType && providerType.template ? this.getFieldsFromString(providerType.template).split(',') : [];

        return (
            <Fragment>
                <Col sm={6} md={3} style={{ marginTop: 15 }}>
                    <Input disabled={this.state.isMenuuAdmin} type="select" name="providerType" id="providerType" style={{}} value={providerType ? providerType.value : null} onChange={this.changeState}>
                        <option value=''>{i18n.t('screens:paymentScreen.chooseProvider')}</option>
                        {
                            this.props.restaurant.paymentProviders.map(provider => {

                                return (
                                    <option
                                        key={provider.id}
                                        id={provider.id}
                                        value={provider.value}
                                        data-template={provider.template}>
                                        {provider.value}
                                    </option>
                                );
                            })
                        }
                    </Input>
                </Col>
                <Row style={{ padding: '0 15px', marginTop: 15 }}>
                    {
                        fields.map(field => {
                            if (field === 'is3DS' || field === 'isDeferredCaptureContracted') {
                                return (
                                    <Col key={`key${field}`} sm={6} style={{ alignSelf: 'end', paddingBottom: '5px' }}>
                                        <AvGroup>
                                            {field === 'isDeferredCaptureContracted' ? 
                                            <Fragment>
                                                <span id={`${field}-info`} style={{ marginRight: '5px' }}>
                                                    <MaterialIcon icon="info" color="#0288D1" size={20} />
                                                </span>
                                                <UncontrolledTooltip placement="top" target={`${field}-info`} >
                                                    {i18n.t('screens:paymentScreen.deferredCaptureInfo')}
                                                </UncontrolledTooltip>
                                            </Fragment> : null
                                            }
                                            <Label>{i18n.t(`screens:paymentScreen.${field}`)}</Label>
                                            <AvInput
                                                type='checkbox'
                                                name={field}
                                                onChange={this.changeSettingsState.bind(this)}
                                                value={settings ? settings[field] : ''}
                                                style={{ position: 'initial', marginLeft: 10 }}
                                                disabled={this.state.isMenuuAdmin} />
                                        </AvGroup>
                                    </Col>
                                )
                            } else {
                                return (
                                    <Col key={`key${field}`} sm={6}>
                                        <AvGroup>
                                            <Label>{i18n.t(`screens:paymentScreen.${field}`)}</Label>
                                            <AvInput
                                                type='text'
                                                required
                                                name={field}
                                                placeholder={i18n.t(`screens:paymentScreen.${field}`)}
                                                onChange={this.changeSettingsState.bind(this)}
                                                value={settings ? settings[field] : ''} 
                                                disabled={this.state.isMenuuAdmin}/>
                                            <AvFeedback>{i18n.t(`common:validations.errorMsg`)}</AvFeedback>
                                        </AvGroup>
                                    </Col>
                                );
                            }
                        })
                    }
                </Row>

            </Fragment>
        );
    }

    transformEmptyTemplateToObject(template) {
        let templateArray = this.getFieldsFromString(template).split(',');
        let settingsObject = {};
        templateArray.map((item) => {
            settingsObject = {
                ...settingsObject,
                [item]: ''
            }
        });

        return settingsObject;
    }

    transformToLocalizeTenderTypes (value) {
        
        switch (value) {
            case "Credit card":
                return i18n.t(`common:paymentTypes.creditCard`);
            case "Cash":
                return i18n.t(`common:paymentTypes.cash`);
            default:
                return;
        }
    }

    getFieldsFromString(stringOfFields) {
        const fields = stringOfFields.replace(/\"/g, "").replace(/\[/g, "").replace(/\]/g, "").replace(/\ /g, "");
        return fields;
    }

    renderPasswordVerification() {
        const { passwordContainer, iconPadding, confirmButton, enterPasswordMsg } = styles

        return (
            <Col md={12} style={passwordContainer}>
                <AvForm onValidSubmit={() => this.checkUserPermission()}>
                    <Row>
                        <span>
                            <MaterialIcon icon="warning" color="#ffc107" size={20} />
                        </span>
                        <p style={enterPasswordMsg}>
                            {i18n.t('screens:posSettingsScreen.enterPasswordMsg')}
                        </p>
                    </Row>
                    <AvGroup>
                        <span className="spanEmailIcon"><MaterialIcon icon="lock" size={20} color="#a9a9a9" />
                            <AvField
                                style={iconPadding}
                                placeholder={i18n.t('common:form.password')}
                                type="password" name="userPassword" id="password" label={i18n.t('common:form.password')}
                                value={this.state.userPassword}
                                onChange={this.changeState}
                                required
                                errorMessage={i18n.t('common:validations.errorMsg')}
                            />
                        </span>
                    </AvGroup>
                    <Button style={confirmButton} color="primary" >
                        {i18n.t('common:buttons.confirm')}
                    </Button>

                </AvForm>
            </Col>
        );
    }

    renderServiceFeesContent() {
        return (
            <Fragment>
                {
                    this.state.serviceFees.length ?
                        <Row style={{width: '100%', margin: 0}}>
                            <div style={{ width: '100%', display: 'flex', alignItems: 'flex-end', flexDirection: 'column', marginBottom: '20px'}}>
                                <Button disabled={this.state.isMenuuAdmin} color="primary" onClick={() => this.toggleModal(undefined, undefined, false)}>
                                    <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('screens:paymentScreen.addFee')}
                                </Button>
                                <p
                                    style={{ color: '#dc3545', fontSize: '80%', marginTop: 10, marginBottom: 0 }}
                                    hidden={!this.state.isStateChanged}>
                                    {i18n.t('common:validations.saveWarningMsg')}
                                </p>
                            </div>
                            <Row style={{width:'100%'}}>
                                <div style={{ minWidth: '100%' }}>
                                    {this.renderServiceFeeItems()}
                                </div>
                            </Row>
                        </Row>
                        : <Row>
                            <div style={{ width: 'calc(100% - 200px)' }}>
                                <p style={{ marginLeft: 16 }}>{i18n.t('screens:paymentScreen.noFees')}</p>
                            </div>
                            <Row>
                                <div style={{ width: 200, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', paddingRight: 16 }} >
                                    <Button disabled={this.state.isMenuuAdmin} color="primary" onClick={() => this.toggleModal(undefined, undefined, false)}>
                                        <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('screens:paymentScreen.addFee')}
                                    </Button>
                                    <p
                                        style={{ color: '#dc3545', fontSize: '80%', marginTop: 10 }}
                                        hidden={!this.state.isStateChanged}>
                                        {i18n.t('common:validations.saveWarningMsg')}
                                    </p>
                                </div>
                            </Row>
                        </Row>
                }
            </Fragment>

        );
    }

    renderServiceFeeItems() {
        const { simpleBillingLabel, noPadding } = styles;
        const currency = this.props.restaurant.currency;
        let paddingOrNoPadding = { ...simpleBillingLabel };
        if (window.innerWidth <= 1650) {
            paddingOrNoPadding.paddingTop = 0;
        }

        return this.state.serviceFees.map((fee, feeIndex) => {
            const serviceFee = (fee.serviceFee === null) ? 0.00 : fee.serviceFee;
            const serviceFeePlaceholder = getPriceWithCurrencySymbol(serviceFee, currency);
            
            const sign = fee.percent ? `%`
            : `${getCurrencySymbol(this.props.restaurant.currency)}`;

            return (
                <Row key={`feeIndex${feeIndex}`} style={{ margin: 0, marginBottom: '10px', justifyContent: 'space-between', alignItems: 'center'}}>

                    <FormGroup style={{ display: 'flex', width: 'calc((100% - 50px) / 12 * 4)', padding: '0 16px', alignItems: 'center'}}>
                        <Label style={simpleBillingLabel}>{i18n.t('screens:paymentScreen.serviceFee')}</Label>
                        <Col style={noPadding, {display: 'flex'}}>
                            <Input type="number" name="amount" disabled
                                style={{width: '90px'}}
                                placeholder={serviceFeePlaceholder}
                                min={0}
                                value={transformProductPrice(Number(fee.amount))}
                                disabled={this.state.isMenuuAdmin}
                            />
                        <div style={{ display: 'flex', padding: '9px 0 0 5px' }}>{sign}</div>
                        </Col>
                    </FormGroup>

                    <FormGroup style={{ display: 'flex', width: 'calc((100% - 50px) / 12 * 3)', padding: '0 16px', alignItems: 'center' }}>
                        <Label style={Object.assign({}, simpleBillingLabel, paddingOrNoPadding), {marginBottom: 0}} for='serviceFeeInPercents'>{i18n.t('screens:paymentScreen.serviceFeeInPercents')}</Label>
                        <Input type='checkbox' name='serviceFeeInPercents' id={fee.id} style={{ top: 0, display: 'flex', position: 'relative', marginLeft: '10px', marginTop: '2px' }}
                            checked={fee.percent} disabled/>
                    </FormGroup>

                    {/* <FormGroup style={{ display: 'flex', width: 'calc((100% - 50px) / 12 * 3)', padding: '0 16px', alignItems: 'center' }}>
                        <Label style={Object.assign({}, simpleBillingLabel, paddingOrNoPadding), {marginBottom: 0}} for='inFavorOfRestaurant'>{i18n.t('screens:paymentScreen.inFavorOfRestaurant')}</Label>
                        <Input type='checkbox' name='inFavorOfRestaurant' id={fee.id} style={{ top: 0, display: 'flex', position: 'relative', marginLeft: '10px', marginTop: '2px' }}
                            checked={fee.inFavorOfRestaurant}
                            disabled />
                    </FormGroup> */}

                    <FormGroup style={{ display: 'flex', width: 'calc((100% - 50px) / 12 * 4)', padding: '0 16px', alignItems: 'center' }}>
                        <Label style={simpleBillingLabel, {marginRight: '15px'}} for='tenderType'>{i18n.t('screens:paymentScreen.applyToPayment')}</Label>
                        <Col style={noPadding}>
                            <Input type='select' name='tenderType' id='tenderType' disabled>
                                <option value={fee.tenderType.value}>{this.transformToLocalizeTenderTypes(fee.tenderType.value)}</option>
                            </Input>
                        </Col>
                    </FormGroup>

                    <div style={{ width: 40, padding: '0 16px', display: 'flex', alignSelf: 'center', justifyContent: 'center', marginBottom: 10, marginRight: '5px', color: '#0288D1', cursor: 'pointer' }}
                        // second param === isEdit
                        onClick={() => this.state.isMenuuAdmin ? null : this.toggleModal(fee, feeIndex, true)}
                        disabled={this.state.isMenuuAdmin}>
                        {i18n.t('common:buttons.edit')}
                    </div>

                </Row>

            );
        });

    }

    saveUpdateFees() {
        this.props.updateRestaurantServiceFees(this.state.serviceFees, () => {
            this.setState({
                ...this.state,
                isStateChanged: false
            });
        });
    }

    renderBankAccount() {
        return (
            <div>
                <BankAccount 
                {...this.props}
                styles={styles}
                isMenuuAdmin={this.state.isMenuuAdmin}
                />
            </div>
        )
    }

    renderCompanyInfo() {
        return (
            <div>
                <CompanyInfo
                {...this.props}
                styles={styles}
                isMenuuAdmin={this.state.isMenuuAdmin}
                 />
            </div>
        )
    }

    renderSubscription() {
        return (
            <div>
                <Subscription
                {...this.props}
                styles={styles}
                isMenuuAdmin={this.state.isMenuuAdmin}
                />
            </div>
        )
    }

    renderAdditionalCharges() {
        return (
            <div>
                <AdditionalCharges
                {...this.props}
                styles={styles}
                isMenuuAdmin={this.state.isMenuuAdmin}
                />
            </div>
        )
    }

    renderAdditionalChargesHistory() {
        return (
            <div>
                <AdditionalChargesHistory
                {...this.props}
                styles={styles}
                isMenuuAdmin={this.state.isMenuuAdmin}
                />
            </div>
        )
    }

    renderInvoices() {
        return (
            <div>
                <Invoices 
                {...this.props}
                styles={styles}
                />
            </div>
        )
    }

    renderInvoicesHistory() {
        return (
            <div>
                <InvoicesHistory 
                {...this.props}
                styles={styles}
                isMenuuAdmin={this.state.isMenuuAdmin}
                />
            </div>
        )
    }

    render() {
        const { containerStyle, headerStyle, spaceBetween, saveBtn } = styles;
        const { restaurant, user } = this.props;
        const fixedPriceSubscription = restaurant.subscription ? restaurant.subscription.fixedPriceSubscription : null;
        const percentPerOrderSubscription = restaurant.subscription ? restaurant.subscription.percentPerOrderSubscription : null;
        const pricePerOrderSubscription = restaurant.subscription ? restaurant.subscription.pricePerOrderSubscription : null;
        const isMenuuMasterAdmin = user ? user.role === MENUU_MASTER_ADMIN : false;
        const companyInfoName = restaurant.companyInfo ? restaurant.companyInfo.name : null;
        const bankCountry = restaurant.bankAccount ? restaurant.bankAccount.bankCountry : null;

        return (
            <React.Fragment>
                <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column' })}>
                    <Row>{this.renderHeader()}</Row>
                    {/* <Row> */}
                    {(this.props.user.canAccessPosSettings) ? this.renderBody() : this.renderPasswordVerification()}
                    {/* </Row> */}
                </div>

                {
                    (this.props.user.canAccessPosSettings) &&

                    <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingRight: 15 })} >
                        <div>
                            <div style={headerStyle}>
                                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.heading')}</span>
                            </div>
                            {this.renderServiceFeesContent()}
                        </div>

                        <Button
                            style={{ display: 'flex', alignSelf: 'flex-end', justifyContent: 'flex-end' }} color="primary"
                            onClick={() => this.saveUpdateFees()}
                            disabled={this.state.isMenuuAdmin}>
                            <span className="saveIcon" style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="save" color="#fff" size={18} /></span>
                            <span style={saveBtn}>{i18n.t('common:buttons.save')}</span>
                        </Button>
                    </div>
                }
                {
                    (this.props.user.canAccessPosSettings) &&
                        <Fragment>
                            <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column' })}>
                                {this.renderCompanyInfo()}
                            </div>
                            <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column' })}>
                                {this.renderBankAccount()}
                            </div>
                        </Fragment>
                }
                {
                    this.props.user.canAccessPosSettings && companyInfoName && bankCountry ?
                    <Fragment>
                        <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column' })}>
                            {this.renderSubscription()}
                        </div>
                        {
                            fixedPriceSubscription || percentPerOrderSubscription || pricePerOrderSubscription ?
                                <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column' })}>
                                    {this.renderAdditionalCharges()}
                                </div> : null
                        }
                        {
                            fixedPriceSubscription || percentPerOrderSubscription || pricePerOrderSubscription ?
                                <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column' })}>
                                    {this.renderAdditionalChargesHistory()}
                                </div> : null
                        }
                        <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column' })}>
                            {this.renderInvoices()}
                        </div>
                    </Fragment> : null
                }

                {
                    this.props.user.canAccessPosSettings && companyInfoName && bankCountry ?
                    <Fragment>
                        <div style={Object.assign({}, containerStyle, { display: 'flex', flexDirection: 'column', minHeight: '160px' })}>
                            {this.renderInvoicesHistory()}
                        </div>
                    </Fragment> : null
                }

                {
                    this.state.isFeesModalOpen &&
                    <ServiceFeesModal
                        isOpen={this.state.isFeesModalOpen}
                        toggle={this.toggleModal}
                        restaurant={this.props.restaurant}
                        feeIndex={this.state.feeIndex}
                        submitData={this.handleNewFee}
                        removeFee={this.removeFee}
                        selectedFee={this.state.selectedServiceFee}
                        tenderTypes={this.props.tenderTypes} />
                }

                {
                    this.state.isPaymentMethodChanged &&
                    <ConfirmationModal
                        isOpen={this.state.isPaymentMethodChanged}
                        onToggle={this.toggleConfirmationWarning}>

                        <ModalHeader className="modalHeader" toggle={this.toggleConfirmationWarning}>{i18n.t('screens:paymentScreen.resetPayment')}</ModalHeader>
                        <ModalBody>
                            <p>{i18n.t('screens:paymentScreen.changePayment')}</p>
                            <p style={{ fontSize: 13 }}>{i18n.t('screens:paymentScreen.changePaymentNote')}</p>
                        </ModalBody>
                        <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                outline
                                color="primary"
                                style={{ width: 60 }}
                                onClick={this.toggleConfirmationWarning}
                                disabled={this.state.isMenuuAdmin}>{i18n.t('screens:paymentScreen.no')}</Button>
                            <Button color="primary" style={{ width: 60 }} onClick={this.resetPaymentMethod}>{i18n.t('screens:paymentScreen.yes')}</Button>
                        </ModalFooter>
                    </ConfirmationModal>
                }
            </React.Fragment>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        restaurant: state.restaurant,
        tenderTypes: state.tenderTypes
    };
};

export default connect(mapStateToProps, {
    getPaymentSettings,
    resetPayment,
    canUserAccessPosSettings,
    resetUserAccessToPos,
    getRestaurantServiceFees,
    loadAllTenderTypes,
    updateRestaurantServiceFees,
    getPaymentProviders,
    updatedPaymentSettings
})(PaymentScreen);

const styles = {
    paymentContainer: { marginTop: 0, paddingLeft: 0 },
    passwordContainer: {
        marginLeft: 15
    },
    iconPadding: {
        paddingLeft: 36,
        width: 286
    },
    confirmButton: {
        width: 286,
        marginBottom: 10
    },
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        padding: '10px 15px',
        width: '100%',
        minHeight: 300
    },
    stripeSymbolStyle: {
        marginRight: 5,
        marginBottom: 4
    },
    columnStyleUserAllowed: {
        marginTop: 60,
        paddingLeft: 18
    },
    columnStyleUserNotAllowed: {
        marginTop: 20,
        paddingLeft: 18
    },
    stripeButton: {
        marginLeft: 5
    },
    warningMsg: {
        fontSize: 14
    },
    spaceBetween: {
        paddingLeft: 4,
        marginTop: -3
    },
    headerStyle: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    sensitiveInformationMsgRow: {
        marginLeft: 18
    },
    sensitiveInformationMsg: {
        margin: '4px 0px 20px 5px',
        fontSize: 14,
        maxWidth: '60%'
    },
    saveBtn: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    },
    simpleBillingCol: { display: 'flex', justifyContent: 'flex-start', float: 'left' },
    simpleBillingLabel: { paddingRight: 0, paddingTop: 9 },
    noPadding: { padding: 0 },
    enterPasswordMsg: { margin: '4px 0px 20px 5px', fontSize: 14, maxWidth: '60%' },
    spaceBetween: {
        paddingLeft: 4,
        marginTop: -3
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/PaymentScreen.js